module.exports = __webpack_public_path__ + "static/background_dark-8081499899f09cc7dd5e21832bfcd017.jpg";